export const PageRoutes = {
    HOME: "/",
    BLOG: "/blog",
    BLOG_DETAIL: "/blog/:id", // Dynamic route for blog details
    PROPERTY: {
        RESIDENTIAL: "/property/residential",
        COMMERCIAL: "/property/commercial",
    },
    ABOUT: "/about",
    CONTACT: "/contact",
    PROPERTY_DETAIL: "/property/:type/:id", // Dynamic route for property details
};
